module.exports = __webpack_public_path__ + "img/shining-nikki.03ae71e.jpg";